/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import React from 'react';
import ContentErrorBoundary from '../components/error/ContentErrorBoundary';

interface AppContextInterface {
}

interface Props {
  Header?: JSX.Element;
  context?: AppContextInterface;
  className?: string;
}

const initialContextState: AppContextInterface = {
};

const AppLayoutContext = React.createContext(initialContextState);

export const AppLayout: React.FC<Props> = (props) => {
  const { context = initialContextState } = props;

  return (
    <AppLayoutContext.Provider value={context} >
      {props.Header}
      <ContentErrorBoundary>
        <div className={`main d-flex ${props.className ?? ''}`}>
          {props.children}
        </div>
      </ContentErrorBoundary>
    </AppLayoutContext.Provider>
  )
}
